
export function isValidEmail(email: string): boolean {
    // Simple RFC 5322 compliant regex for most use cases
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}